jQuery(document).ready(function ($) {
  $(".gallery_list").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 481,
        settings: {
          arrows: false,
          dots: true,
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".list-menu li").on("click", "a", function (event) {
    var navAnchor = $($(this).attr("href"));
    var moveSection = navAnchor.offset().top - 150;
    $("html, body").animate({ scrollTop: moveSection });
    event.preventDefault();
  });

  $(".testimonial__list").slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          centerMode: false,
          autoplay: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// Fancybox Configuration
$('[data-fancybox="gallery"]').fancybox({
  buttons: ["slideShow", "thumbs", "zoom", "fullScreen", "share", "close"],
  loop: false,
  protect: true,
});

// Show the first tab by default
$(".tabs-container div").hide();
$(".tabs-container div:first").show();
$(".tabs-nav li:first").addClass("tab-active");

// Change tab class and display content
$(".tabs-nav a").on("click", function (event) {
  event.preventDefault();
  $(".tabs-nav li").removeClass("tab-active");
  $(this).parent().addClass("tab-active");
  $(".tabs-container div").hide();
  $($(this).attr("href")).show();
});

// Counter To Count Number Visit
var a = 0;
$(window).scroll(function () {
  var $counter = $("#counter");
  if ($counter.length === 0) {
    return; // Exit if the #counter element doesn't exist
  }

  var oTop = $counter.offset().top - window.innerHeight;

  if (a === 0 && $(window).scrollTop() > oTop) {
    $(".counter").each(function () {
      var $this = $(this);
      jQuery({ Counter: 0 }).animate(
        { Counter: $this.text() },
        {
          duration: 2000,
          easing: "swing",
          step: function () {
            $this.text(Math.ceil(this.Counter));
          },
        }
      );
    });
    a = 1;
  }
});
